class AccessibleAccordion extends HTMLElement {
    constructor() {
        super();
        this.triggers = [];
    }

    connectedCallback() {
        this.init();
    }

    init() {
        const items = this.querySelectorAll(':scope > .accessible-accordion-item');
        const singleMode = this.hasAttribute('single');
        const openByDefault = this.hasAttribute('data-open');

        items.forEach((item, index) => {
            const trigger = item.querySelector('.accordion-trigger');
            const panel = item.querySelector('.accordion-panel');

            const triggerId = `acc-trigger-${index}-${Date.now()}`;
            const panelId = `acc-panel-${index}-${Date.now()}`;

            trigger.setAttribute('id', triggerId);
            trigger.setAttribute('aria-controls', panelId);
            trigger.setAttribute('aria-expanded', 'false');

            panel.setAttribute('id', panelId);
            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-labelledby', triggerId);
            panel.hidden = true;

            this.triggers.push(trigger);

            trigger.addEventListener('click', () => {
                this.toggle(trigger, singleMode);
            });
            if (openByDefault) {
                this.toggle(trigger, singleMode);
            }

            trigger.addEventListener('keydown', (e) => {
                this.handleKeydown(e, index);
            });
        });
        this.setAnchorTitle();
    }

    toggle(trigger, singleMode) {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const panel = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
        const willOpen = !isExpanded;

        // Only update Swiper when the panel is being opened,
        // using the same helper that `home-featured-tabbed-slider.js` uses.
        if (willOpen && panel) {
            requestAnimationFrame(() => {
                if (window._homeFeaturedTabSlider &&
                    typeof window._homeFeaturedTabSlider.initSlidersIn === 'function') {
                    window._homeFeaturedTabSlider.initSlidersIn(panel);
                    return;
                }

                // Fallback: update already-initialized Swiper instances in the panel.
                panel.querySelectorAll('slideshow-container, .swiper').forEach((sliderEl) => {
                    const swiper = sliderEl.swiper;
                    if (!swiper) return;
                    swiper.update();
                    if (typeof swiper.updateSlides === 'function') {
                        swiper.updateSlides();
                    }
                });
            });
        }

        // If parent wrapper has [data-single-open], close ALL sibling accordions first
        if (willOpen && this.parentElement && this.parentElement.hasAttribute('data-single-open')) {
            this.parentElement.querySelectorAll(':scope > accessible-accordion').forEach(sibling => {
                if (sibling === this) return;
                sibling.querySelectorAll('.accordion-trigger').forEach(btn => {
                    btn.setAttribute('aria-expanded', 'false');
                    const p = sibling.querySelector(`#${btn.getAttribute('aria-controls')}`);
                    if (p) p.hidden = true;
                });
            });
        }

        if (singleMode) {
            this.triggers.forEach(btn => {
                btn.setAttribute('aria-expanded', 'false');
                const p = this.querySelector(`#${btn.getAttribute('aria-controls')}`);
                if (p) p.hidden = true;
            });
        }

        trigger.setAttribute('aria-expanded', !isExpanded);
        panel.hidden = isExpanded;
    }

    handleKeydown(e, index) {
        const key = e.key;
        const triggers = this.triggers;

        switch (key) {
            case 'ArrowDown':
                e.preventDefault();
                this.focusTrigger(index + 1);
                break;
            case 'ArrowUp':
                e.preventDefault();
                this.focusTrigger(index - 1);
                break;
            case 'Home':
                e.preventDefault();
                triggers[0].focus();
                break;
            case 'End':
                e.preventDefault();
                triggers[triggers.length - 1].focus();
                break;
            case 'Enter':
            case ' ':
                e.preventDefault();
                this.toggle(triggers[index], this.hasAttribute('single'));
                break;
        }
    }

    focusTrigger(index) {
        const triggers = this.triggers;

        if (index < 0) index = triggers.length - 1;
        if (index >= triggers.length) index = 0;

        triggers[index].focus();
    }
    setAnchorTitle(){
        this.querySelectorAll('a[title] ,a').forEach(anchor => {
            if(anchor.hasAttribute('target', '_blank')){
                anchor.setAttribute('aria-label', anchor.innerText + ' opens in a new tab');
                anchor.removeAttribute('title');
            }
        });
    }
}

customElements.define('accessible-accordion', AccessibleAccordion);